import { randomString } from '@fabric-app/utils/random';
import { DecorationSet, Decoration } from '@tiptap/pm/view';
import { getPath } from '../utils.js';

class ContextualMenuState {
  constructor(params) {
    this.specType = null;
    this.active = null;
    this.range = {
      from: 0,
      to: 0
    };
    this.query = null;
    this.decorations = DecorationSet.empty;
    this.summoned = false;
    this.emptyBlock = false;
    this.mobile = false;
    Object.assign(this, params);
  }
  static get empty() {
    return new ContextualMenuState({
      specType: null,
      active: null,
      range: {
        from: 0,
        to: 0
      },
      query: null,
      decorations: DecorationSet.empty,
      summoned: false,
      emptyBlock: false,
      mobile: false
    });
  }
  update(params) {
    return new ContextualMenuState({
      ...this,
      ...params
    });
  }
  reset() {
    return ContextualMenuState.empty;
  }
  applyMeta(tr, meta) {
    if (!meta.spec) return this.reset();
    const decoId = `cm-${randomString(10)}`;
    return this.update({
      specType: meta.spec.name,
      active: meta.spec,
      range: {
        from: meta.from,
        to: meta.to
      },
      query: "",
      decoId,
      summoned: meta.summoned,
      mobile: meta.mobile
    });
  }
  applyDecoration(tr) {
    if (!this.active || this.mobile) return this;
    const resolved = tr.doc.resolve(this.range.from);
    const path = getPath(resolved);
    const parent = path[0];
    if (!parent || path.length < 2) return this;
    const emptyBlock = parent.node.content.size === 0;
    const customSelector = this.active?.customSelector;
    const decorationFullNode = customSelector || emptyBlock;
    const from = parent.before;
    const to = parent.after;
    const attrs = {
      class: `contextual-menu ${this.active?.decorationClass ?? ""}`,
      id: this.decoId,
      "data-contextual-menu-placeholder": this.query?.length === 0 ? this.active?.placeholder : void 0
    };
    return this.update({
      emptyBlock,
      decorations: DecorationSet.create(tr.doc, decorationFullNode ? [
        Decoration.node(from, to, {
          ...attrs,
          class: customSelector ? `contextual-menu-selected` : `contextual-menu-node ${this.active?.decorationClass ?? ""}`
        })
      ] : [
        Decoration.inline(this.range.from, this.range.to, attrs, {
          inclusiveEnd: true
        })
      ])
    });
  }
  mapRange(mapping) {
    if (!this.active) return this;
    return this.applyNewRange({
      from: mapping.map(this.range.from),
      to: mapping.map(this.range.to)
    });
  }
  applyNewRange(range) {
    return this.update({
      range: {
        from: range.from,
        to: range.to
      }
    });
  }
}

export { ContextualMenuState };
//# sourceMappingURL=ContextualMenuState.js.map
